import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

interface DeleteVideoInterface {
  vid: string;
}

export const useDeleteVRVideoByID = () => {
  const mutate = useMutation(({ vid }: DeleteVideoInterface) => {
    return get(`/external-api/deleteVRVideoById/${vid}`);
  });

  return mutate;
};

export default useDeleteVRVideoByID;
